import { createWizard } from '@/components/ui';

import { NewState } from './New';

export const { useWizard, Wizard } = createWizard<NewState>();
